import { render } from "./OmaVolume.vue?vue&type=template&id=901d7fee"
import script from "./OmaVolume.vue?vue&type=script&lang=js"
export * from "./OmaVolume.vue?vue&type=script&lang=js"

import "./OmaVolume.vue?vue&type=style&index=0&id=901d7fee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__